import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  statusVote: null,
  startVote: null,
  endVote: null,
  votes: [],
  teams: [],
  result: [],
  color: [],
  timeout: 0
}

export const getters = {
  statusVote: state => state.statusVote,
  startVote: state => state.startVote,
  endVote: state => state.endVote,
  votes: state => state.votes,
  teams: state => state.teams,
  result: state => state.result,
  color: state => state.color,
  timeout: state => state.timeout
}

export const mutations = {
  // member general page data
  [types.SUMMERTRIPVOTE.GET_VOTE_STATUS](state, payload) {
    state.statusVote = payload.status_vote;
    state.startVote = payload.start;
    state.endVote = payload.end;
  },
  [types.SUMMERTRIPVOTE.GET_VOTES](state, payload) {
    state.votes = payload.votes;
    state.teams = payload.teams;
    state.result = payload.result;
    state.color = payload.color;
  },
  [types.SUMMERTRIPVOTE.GET_TIMEOUT](state, payload) {
    state.timeout = payload;
  },

}

export const actions = {
  // get data for member general page
  start(_, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + payload.year + "/" + payload.period + api.SUMMER_TRIP_VOTE.START,
        method: 'POST'
      }).then(response => {
        // commit(types.SUMMERTRIPVOTE.START, response.data ? response.data : {})
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  end(_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + payload.year + "/" + payload.period + api.SUMMER_TRIP_VOTE.END,
        method: 'POST'
      }).then(response => {
        // commit(types.SUMMERTRIPVOTE.END, response.data ? response.data : {})
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  getVoteStatus({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + payload.year + "/" + payload.period + api.SUMMER_TRIP_VOTE.GET_STATUS_VOTE,
        method: 'GET'
      }).then(response => {
        commit(types.SUMMERTRIPVOTE.GET_VOTE_STATUS, response.data ? response.data : {})
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  getVotes({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + payload.year + "/" + payload.period + api.SUMMER_TRIP_VOTE.GET_VOTES,
        method: 'GET'
      }).then(response => {
        commit(types.SUMMERTRIPVOTE.GET_VOTES, response.data ? response.data : [])
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  getTimeout({commit}) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + api.SUMMER_TRIP_VOTE.GET_TIMEOUT,
        method: 'GET'
      }).then(response => {
        commit(types.SUMMERTRIPVOTE.GET_TIMEOUT, response.data ? response.data : 0)
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  resetVote(_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.SUMMER_TRIP_VOTE.API_VOTE + payload.year + "/" + payload.period + api.SUMMER_TRIP_VOTE.RESET,
        method: 'POST'
      }).then(response => {
        // commit(types.SUMMERTRIPVOTE.END, response.data ? response.data : {})
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
}
